// 菜单，侧边栏
import system from './modules/system';
import market from './modules/market';
import canteen from './modules/canteen';
import log from './modules/log';
export default [
// dashboard,
{
  path: "/workspace/home",
  title: '商铺一张图',
  header: 'home',
  icon: 'md-map',
  name: 'workspace-home'
}, market, canteen, {
  path: "/market/stall-manage",
  title: '铺面维护',
  header: 'system',
  hideSider: true
}, log, system];